export const UPDATE_PAYIN_AMOUNT_LOCK_STATUS = 'updatePayinLockStatus';

export const lockPayinAmount = () => updatePayinAmountLockStatus(true);

export const unlockPayinAmount = () => updatePayinAmountLockStatus(false);

const updatePayinAmountLockStatus = (locked: boolean) => ({
    type: UPDATE_PAYIN_AMOUNT_LOCK_STATUS,
    payload: locked,
});
